import { SearchCustomersQuery } from '../types';

const buildQueryKey = ({
    agentId,
    searchQuery,
    createdAt,
    preferredLanguage,
    tags,
    hasNewMessage,
    sortBy,
    sortOrder,
    pageSize,
    page = 1,
}: Omit<SearchCustomersQuery, 'queryOptions'>) => {
    const key: unknown[] = ['customers', 'search'];
    if (agentId) {
        key.push(agentId);
    }
    if (searchQuery) {
        key.push(searchQuery);
    }
    if (createdAt) {
        key.push(createdAt);
    }
    if (preferredLanguage) {
        key.push(preferredLanguage);
    }
    if (tags) {
        key.push(tags);
    }
    if (hasNewMessage) {
        key.push(hasNewMessage);
    }
    if (sortBy) {
        key.push(sortBy);
    }
    if (sortOrder) {
        key.push(sortOrder);
    }
    if (pageSize) {
        key.push(pageSize);
    }

    key.push(page);

    return key;
};

export default buildQueryKey;
